<template>
  <header>
    <div v-if="this.image" class="header" :style="backgroundImage"></div>
    <Progress v-if="renderProgressBar" :questions="this.progress_questions" />
  </header>
</template>

<script>
import Progress from './Progress.vue'

export default {
  name: 'Header',
  components: {
    Progress
  },
  props: ['image','progress_questions',],
  data: function(){
      return{
          background: null,
      }
  },
  methods: {
  },
  computed: {
    renderProgressBar(){
      if(this.index !== null){
        return true;
      }
      else return false;
    },
    backgroundImage(){
      return "background-image: url("+this.image+");"
    }
  }
}
</script>
